import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URLS } from "./apis/urls";
import Api from "./utils/apiCall";

interface ShiftVerificationState {
  data: any;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | "update" | "get" | null;
}

const shiftVerificationInitialState: ShiftVerificationState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};

export const getShifts: any = createAsyncThunk(
  "get/shifts-approvals",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.WORK_SHIFT.SHIFT_APPROVALS, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);


export const changeStatus: any = createAsyncThunk(
  "change-status/shifts-approvals",
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(API_URLS.WORK_SHIFT.CHANGE_STATUS, payload);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);










const shiftVerificationSlice = createSlice({
  name: "reset",
  initialState: shiftVerificationInitialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.data = null;
      state.action = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getShifts.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getShifts.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "list";
    });
    builder.addCase(getShifts.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "list";
    });




    builder.addCase(changeStatus.pending, (state) => {
      state.loading = "pending";
      state.data = null;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(changeStatus.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.data = action.payload;
      state.error = null;
      state.action = "update";
    });
    builder.addCase(changeStatus.rejected, (state, action) => {
      state.loading = "rejected";
      state.error = action.payload as string;
      state.data = null;
      state.action = "update";
    });
  }
});

export const { resetAll } = shiftVerificationSlice.actions;
export default shiftVerificationSlice.reducer;
